export const INFINITY_SCROLL_DELTA_PX = 100;
export const BREAKPOINT_SMALL = "640px";

export const CUSTOM_FIELD_PREFIX = "cf_";

export const REACTIVE_QUERY_TABLE_SETTINGS = "reactive_query_table_settings";
export const RESIZE_OBSERVER_DEBOUNCE_TIME_MS = 100;

export const DEFAULT_DEBOUNCE_SEARCH = 500;

export const SELECT_TEXT_DEBOUNCE_TIME_MS = 300;

export const IME_PROCESSING_KEY_CODE = 229;

export const VUE_MODAL_BEM_BLOCK = "vue-modal";

export const LINK_ALLOWED_PROTOCOLS = ["http:", "https:"];

export const SIMPLE_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
